import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'changelog-editor-forbidden',
  standalone: true,
  template: `
    <div style="text-align:center;padding:4rem;">
      <h1>403 – Forbidden</h1>
      <p>You do not have permission to access this page.</p>
      <button (click)="goBack()" style="margin-top:1rem;padding:0.5rem 1.5rem;cursor:pointer;">
        Go back
      </button>
    </div>
  `
})
export class ForbiddenComponent {
  constructor(private router: Router, private route: ActivatedRoute) {}

  goBack(): void {
    this.router.navigate(['..'], { relativeTo: this.route });
  }
}
